import React from 'react';
import { useParams } from 'react-router-dom';

import Txt from '../components/Txt';
import Button from '../components/Button';
import ContentWrapper from '../components/ContentWrapper';
import Dialog from '../components/Dialog';
import { useVolumeLicense } from '../utils/volumeLicense';
import InviteToVolumeLicenseDialog from '../components/InviteToVolumeLicenseDialog';
import SimpleTable4 from '../components/SimpleTable4';

const VolumeLicenseDetailView = (): JSX.Element | null => {
	const { id } = useParams();
	const volumeLicenses = useVolumeLicense(id);
	const trainees = volumeLicenses?.users?.map((trainee) => ({
		'id': trainee.id,
		'Vorname': trainee.firstName,
		'Nachname': trainee.lastName,
		'Email': trainee.email,
		'Email bestätigt': trainee.emailConfirmed ? 'Ja' : 'Nein',
	}));

	const handleOpenInviteToVolumeLicenseDialog = React.useCallback(() => {
		Dialog.render({
			renderContent: ({ dismissPortal }) => (
				<InviteToVolumeLicenseDialog dismissPortal={dismissPortal} id={id} />
			),
			isLocked: true,
		});
	}, [id]);

	return !trainees ? (
		<ContentWrapper>{null}</ContentWrapper>
	) : (
		<ContentWrapper p="2rem">
			<Txt m="0 0 2rem 0" variant="h6">
				Volumenlizenzen Nutzer
			</Txt>
			{!trainees.length ? null : <SimpleTable4 renderData={trainees} />}
			<Button m="1rem 0 0 0" variant="mainButton" onClick={handleOpenInviteToVolumeLicenseDialog}>
				Hinzufügen
			</Button>
		</ContentWrapper>
	);
};

export default VolumeLicenseDetailView;
